import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import axios from 'src/devias/utils/axios';

interface CalendarSliceState {
  events: any[];
  isModalOpen: boolean;
  selectedEventId: string | null;
  selectedRange: { start: number; end: number } | null;
}

const initialState: CalendarSliceState = {
  events: [],
  isModalOpen: false,
  selectedEventId: null,
  selectedRange: null
};

const slice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    getEvents(state, action: PayloadAction<{ events: any[] }>) {
      const { events } = action.payload;

      state.events = events;
    },
    createEvent(state, action: PayloadAction<{ event: any }>) {
      const { event } = action.payload;

      state.events = [...state.events, event];
    },
    selectEvent(state, action: PayloadAction<{ eventId?: string | null }>) {
      const { eventId = null } = action.payload;

      state.isModalOpen = true;
      state.selectedEventId = eventId ?? null;
    },
    updateEvent(state, action: PayloadAction<{ event: any }>) {
      const { event } = action.payload;

      state.events = _.map(state.events, (_event) => {
        if (_event.id === event.id) {
          return event;
        }

        return _event;
      });
    },
    deleteEvent(state, action: PayloadAction<{ eventId: string }>) {
      const { eventId } = action.payload;

      state.events = _.reject(state.events, { id: eventId });
    },
    selectRange(state, action: PayloadAction<{ start: number; end: number }>) {
      const { start, end } = action.payload;

      state.isModalOpen = true;
      state.selectedRange = {
        start,
        end
      };
    },
    openModal(state) {
      state.isModalOpen = true;
    },
    closeModal(state) {
      state.isModalOpen = false;
      state.selectedEventId = null;
      state.selectedRange = null;
    }
  }
});

export const reducer = slice.reducer;

export const getEvents = () => async (dispatch: any) => {
  const response = await axios.get('/api/calendar/events');

  dispatch(slice.actions.getEvents(response.data));
};

export const createEvent = (data: any) => async (dispatch: any) => {
  const response = await axios.post('/api/calendar/events/new', data);

  dispatch(slice.actions.createEvent(response.data));
};

export const selectEvent = (eventId: string) => async (dispatch: any) => {
  dispatch(slice.actions.selectEvent({ eventId }));
};

export const updateEvent = (eventId: string, update: any) => async (dispatch: any) => {
  const response = await axios.post('/api/calendar/events/update', {
    eventId,
    update
  });

  dispatch(slice.actions.updateEvent(response.data));
};

export const deleteEvent = (eventId: string) => async (dispatch: any) => {
  await axios.post('/api/calendar/events/remove', {
    eventId
  });

  dispatch(slice.actions.deleteEvent({ eventId }));
};

export const selectRange = (start: Date, end: Date) => (dispatch: any) => {
  dispatch(slice.actions.selectRange({
    start: start.getTime(),
    end: end.getTime()
  }));
};

export const openModal = () => (dispatch: any) => {
  dispatch(slice.actions.openModal());
};

export const closeModal = () => (dispatch: any) => {
  dispatch(slice.actions.closeModal());
};

export default slice;
